import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M16.023.025C7.195.025.06 7.17.06 15.986c0 6.766 4.204 12.546 10.142 14.872-.145-1.262-.263-3.206.053-4.585.288-1.248 1.865-7.935 1.865-7.935s-.473-.96-.473-2.365c0-2.22 1.287-3.875 2.89-3.875 1.366 0 2.023 1.024 2.023 2.246 0 1.367-.867 3.416-1.327 5.32-.38 1.59.802 2.89 2.365 2.89 2.838 0 5.018-2.994 5.018-7.303 0-3.823-2.745-6.49-6.673-6.49-4.546 0-7.212 3.403-7.212 6.923 0 1.367.525 2.838 1.182 3.64a.475.475 0 0 1 .105.459c-.118.5-.394 1.59-.447 1.813-.065.289-.236.355-.538.21-1.97-.946-3.206-3.862-3.206-6.2 0-5.032 3.652-9.656 10.55-9.656 5.53 0 9.839 3.94 9.839 9.222 0 5.504-3.468 9.931-8.276 9.931-1.616 0-3.14-.84-3.652-1.839l-.999 3.797c-.355 1.392-1.327 3.127-1.984 4.19 1.498.46 3.075.71 4.73.71 8.815 0 15.961-7.146 15.961-15.961C31.984 7.17 24.837.024 16.023.024Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }